import React, { useState, useContext, useEffect } from "react";

import { Check } from "react-feather";

import { FormTextInput } from "../../Components/FormTextInput";

import { languages } from "../../Data/languages";

import { useScreenTransition } from "../../Hooks/useScreenTransition";
import { useEnterKey } from "../../Hooks/useEnterKey";

import { AuthContext } from "../../Context/AuthContext";
import { NotificationContext } from "../../Context/NotificationContext";
import { DataContext } from "../../Context/DataContext";

import "./OrderOptions.css";
import TopBar from "../../Components/TopBar";
import SecureAndPrivate from "../../NewComponents/SecureAndPrivate";
import LogoAuthNavbar from "../../NewComponents/LogoAuthNavbar";
import CreateOrderNav from "../../NewComponents/CreateOrderNav";
import NewButton from "../../NewComponents/NewButton";

import { ReactComponent as NOTRY } from "../../assets/icons/Notarization.svg";
import { ReactComponent as EXPEDITED } from "../../assets/icons/expedited.svg";
import { ReactComponent as EXPEDITEDPLUS } from "../../assets/icons/expedited-plus.svg";
import { ReactComponent as HARDCOPY } from "../../assets/icons/HardCopy.svg";
import { ReactComponent as MORE } from "../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../assets/icons/More-selected.svg";
import SearchSelect from "../../NewComponents/SearchSelect";
import { expeditedPlusLanguages } from "../../Data/ExpeditePlusLanguages";
import { v4 as uuidv4 } from "uuid";
import {
  getExpeditedFeeOption,
  getExpeditedPriceLabel,
  formatDiscount,
  formatTotal,
  getDiscount,
  getExpedited,
  getHardCopyPrice,
  getOrderPageCountTotal,
  getTotal,
  getExpeditedFreeOrders,
} from "../../Data/Functions";
import { Country, State, City } from "country-state-city";
import { auth, firestore } from "../../firebase.config";
import PopUpModal from "../../NewComponents/PopUpModal";
import { ReactComponent as ADDRESS } from "../../assets/icons/Address.svg";
import SelectSearch from "../../NewComponents/select-search";
import { getCounter } from "../../Data/Functions/getCounter";

const emailRegex = new RegExp(
  "^[a-zA-Z0-9._+%-]+@[a-zA-Z0-9-]+\\.[a-zA-Z]{2,}(\\.?[a-z]{2})?$"
);

export const USPriorDelivery = [
  {
    label: "USPS Priority: 2-3 days - $19.95",
    value: "priority",
  },
  {
    label: "USPS Express: 1-2 days - $37.95",
    value: "express",
  },
];

export const otherCitiesDelivery = [
  {
    label: "USPS Priority: 6-10 days - $49.95",
    value: "priority",
  },
  {
    label: "USPS Express: 3-5 days - $78.95",
    value: "express",
  },
];

const OrderOptions = ({ windowSize }) => {
  const countries = Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode,
  }));

  const { transitionTo } = useScreenTransition();
  const { showNotification } = useContext(NotificationContext);

  const { signedIn } = useContext(AuthContext);

  const { order, setOrder, userData, teamData } = useContext(DataContext);

  useEffect(() => {
    if (order.parsed && order.type === "") {
      transitionTo("/order/type");
    } else if (
      order.parsed &&
      (order.orderID === "" ||
        !order.languageFrom ||
        order.languageFrom === "" ||
        !order.languageTo ||
        order.languageTo === "" ||
        !order.files ||
        order.files.length === 0)
    ) {
      transitionTo("/order/documents");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order]);

  const [continueButton, setContinueButton] = useState(
    signedIn ? "Continue to Payment" : "Continue to Contact"
  );

  const [notarization, setNotarization] = useState(false);
  const [expedited, setExpedited] = useState(false);
  const [expeditedPlus, setExpeditedPlus] = useState(false);
  const [hardCopy, setHardCopy] = useState(false);

  const [hardCopyCountry, setHardCopyCountry] = useState({label: "", value: ""});
  
  const [hardCopyMethod, setHardCopyMethod] = useState("");
  const [hardCopyRequireSignature, setHardCopyRequireSignature] =
    useState(false);

  const [hardCopyFirstName, setHardCopyFirstName] = useState("");
  const [hardCopyLastName, setHardCopyLastName] = useState("");
  const [hardCopyState, setHardCopyState] = useState({label: "", value: ""});
  const [hardCopyCity, setHardCopyCity] = useState({label: "", value: ""});
  const [hardCopyZipCode, setHardCopyZipCode] = useState("");
  const [hardCopyStreet, setHardCopyStreet] = useState("");
  const [hardCopyApartment, setHardCopyApartment] = useState("");
  const [newAddressModal, setNewAddressModal] = useState(false);
  const [editAddressIconSelected, setEditAddressIconSelected] = useState("");
    const [deleteModalAddress, setDeleteModalAddress] = useState(null);
    const [deleteBtnText, setDeleteBtnText] = useState('Delete Address');

  const [saveAddress, setSaveAddress] = useState(false);
  const [addressName, setAddressName] = useState("");
  const [selectedMyAddress, setSelectedMyAddress] = useState("");
  const [selectedMyCountry, setSelectedMyCountry] = useState("");
  const [selectedMyMethod, setSelectedMyMethod] = useState("");
  const [editAddress, setEditAddress] = useState("");

  const [clientFirstName, setClientFirstName] = useState("");
  const [clientLastName, setClientLastName] = useState("");
  const [similarClients, setSimilarClients] = useState([]);

  const [editFirstName, setEditFirstName] = useState("");
  const [editLastName, setEditLastName] = useState("");
  const [editState, setEditState] = useState({label: "", value: ""});
  const [editCity, setEditCity] = useState({label: "", value: ""});
  const [editZipCode, setEditZipCode] = useState("");
  const [editStreet, setEditStreet] = useState("");
  const [editApartment, setEditApartment] = useState("");
  const [editCountry, setEditCountry] = useState({label: "", value: ""});
  const [editAddressName, setEditAddressName] = useState("");
  const [saveEditsBtnText, setSaveEditsBtnText] = useState("Save");
  const [myDeliveryFocus, setMyDeliveryFocus] = useState({
    country: false,
    delivery: false,
  });
  const [newDeliveryFocus, setNewDeliveryFocus] = useState({
    country: false,
    delivery: false,
  });

  const [activeDropdown, setActiveDropdown] = useState(null);
  

  const getStates = (selectedCountry) =>  State.getStatesOfCountry(selectedCountry).map(state => ({
          label: state.name,
          value: state.isoCode
        }));
    
      const getCities = (selectedState, selectedCountry) => City.getCitiesOfState(selectedCountry, selectedState).map(city => ({
          label: city.name,
          value: city.name
        }));

  useEffect(() => {
    setNotarization(order.notarization || false);
    setExpedited(order.expedited || false);
    setExpeditedPlus(
      getExpeditedPlusAvaliblity() ? order.expeditedPlus || false : false
    );
    setHardCopy(order.hardCopy || false);

    
      if (order.hardCopyExtra && order.hardCopyExtra.newAddress) {
        setHardCopyMethod(
          order.hardCopyExtra ? order.hardCopyExtra.method || "" : ""
        );
      } else {
        setSelectedMyMethod(
          order.hardCopyExtra ? order.hardCopyExtra.method || "" : ""
        );
      }
      setHardCopyCountry(
        order.hardCopyExtra ? {label: order.hardCopyExtra.country, value: order.hardCopyExtra.countryIsoCode } || "" : ""
      );
      setHardCopyFirstName(
        order.hardCopyExtra ? order.hardCopyExtra.firstName || "" : ""
      );
      setHardCopyLastName(
        order.hardCopyExtra ? order.hardCopyExtra.lastName || "" : ""
      );
      setHardCopyState(
        order.hardCopyExtra ? {label: order.hardCopyExtra.region, value: order.hardCopyExtra.regionIsoCode } || "" : ""
      );
      setHardCopyCity(
        order.hardCopyExtra ? {label: order.hardCopyExtra.city, value: order.hardCopyExtra.cityIsoCode } || "" : ""
      );
      setHardCopyZipCode(
        order.hardCopyExtra ? order.hardCopyExtra.zipCode || "" : ""
      );
      setHardCopyStreet(
        order.hardCopyExtra ? order.hardCopyExtra.street || "" : ""
      );
      setHardCopyApartment(
        order.hardCopyExtra ? order.hardCopyExtra.apartment || "" : ""
      );
      setHardCopyRequireSignature(
        order.hardCopyExtra
          ? order.hardCopyExtra.requireSignature || false
          : false
      );
    if (order.hardCopyExtra && order.hardCopyExtra.saveAddress) {
      setSaveAddress(
        order.hardCopyExtra ? order.hardCopyExtra.saveAddress || false : false
      );
      setAddressName(
        order.hardCopyExtra ? order.hardCopyExtra.addressName || "" : ""
      );
    }

      setSelectedMyAddress(
        order.hardCopyExtra ? order.hardCopyExtra.id || "" : ""
      );
      setNewAddressModal(
        order.hardCopyExtra ? order.hardCopyExtra.newAddress || false : false
      );

      setClientFirstName(order.clientFirstName ? order.clientFirstName : "");
      setClientLastName(order.clientLastName ? order.clientLastName : "");
    
  }, [order]);
  

  useEffect(() => {
     if (
       signedIn &&
       userData && teamData &&
       teamData.shipping &&
       teamData.shipping.length > 0
     ) {
       if (selectedMyAddress !== "") {
         const addressSelected = teamData.shipping.find(
           (address) => address.id === selectedMyAddress
         );
         if (addressSelected) {
           setSelectedMyAddress(addressSelected.id);
           setSelectedMyCountry(addressSelected.country);
 
           setHardCopyCountry(addressSelected.country);
           setHardCopyFirstName(addressSelected.firstName);
           setHardCopyLastName(addressSelected.lastName);
           setHardCopyState(addressSelected.region);
           setHardCopyCity(addressSelected.city);
           setHardCopyZipCode(addressSelected.zipCode);
           setHardCopyStreet(addressSelected.street);
           setHardCopyApartment(addressSelected.apartment);
           setAddressName(addressSelected.addressName);
         }
       } else {
         const address = teamData.shipping.find(
           (address) => address.default === true
         );
         if (address) {
           setSelectedMyAddress(address.id);
           setSelectedMyCountry(address.country);
 
           setHardCopyCountry(address.country);
           setHardCopyFirstName(address.firstName);
           setHardCopyLastName(address.lastName);
           setHardCopyState(address.region);
           setHardCopyCity(address.city);
           setHardCopyZipCode(address.zipCode);
           setHardCopyStreet(address.street);
           setHardCopyApartment(address.apartment);
           setAddressName(address.addressName);
         }
       }
       setAddressName(
        order.hardCopyExtra ? order.hardCopyExtra.addressName || "" : ""
       );
       return;
     } 
     if (
       signedIn &&
       userData &&
       userData.shipping &&
       userData.shipping.length > 0
     ) {
       if (selectedMyAddress !== "") {
         const addressSelected = userData.shipping.find(
           (address) => address.id === selectedMyAddress
         );
         if (addressSelected) {
           setSelectedMyAddress(addressSelected.id);
           setSelectedMyCountry(addressSelected.country);
 
           setHardCopyCountry(addressSelected.country);
           setHardCopyFirstName(addressSelected.firstName);
           setHardCopyLastName(addressSelected.lastName);
           setHardCopyState(addressSelected.region);
           setHardCopyCity(addressSelected.city);
           setHardCopyZipCode(addressSelected.zipCode);
           setHardCopyStreet(addressSelected.street);
           setHardCopyApartment(addressSelected.apartment);
           setAddressName(addressSelected.addressName);
         }
       } else {
         const address = userData.shipping.find(
           (address) => address.default === true
         );
         if (address) {
           setSelectedMyAddress(address.id);
           setSelectedMyCountry(address.country);
 
           setHardCopyCountry(address.country);
           setHardCopyFirstName(address.firstName);
           setHardCopyLastName(address.lastName);
           setHardCopyState(address.region);
           setHardCopyCity(address.city);
           setHardCopyZipCode(address.zipCode);
           setHardCopyStreet(address.street);
           setHardCopyApartment(address.apartment);
           setAddressName(address.addressName);
         }
       }
       setAddressName(
         order.hardCopyExtra ? order.hardCopyExtra.addressName || "" : ""
       );
       return;
     } 
       setNewAddressModal(true);
     // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [signedIn, userData, teamData, selectedMyAddress]);

  useEffect(() => {
    if (hardCopy && hardCopyCountry === "") {
      setHardCopyMethod("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hardCopyCountry]);

  const capitalize = (value) => {
    if (value.length > 1) {
      const array = value.split(" ");
      const capitalizeWordArray = array.map((data) => {
        if (data.length > 1) {
          return (
            data.slice(0, 1).toUpperCase() + data.slice(1, -1) + data.slice(-1)
          );
        }
        return data.toUpperCase();
      });
      return capitalizeWordArray.join(" ");
    } else {
      return value.toUpperCase();
    }
  };

  useEffect(() => {
    if (hardCopy && selectedMyAddress === "") {
      setSelectedMyMethod("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMyCountry]);

  const getClientsDetails = async () => {
    
    let clients = [];

    await firestore
      .collection("orders")
      .where("teamId", "==", userData.teamId)
      .where("clientFirstName", "==", clientFirstName.toLowerCase())
      .get()
      .then((qSnap) => {
        if (!qSnap.empty) {
          let data = qSnap.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
          let filteredClientsName = [];

          data
            .filter((n) =>
              clientLastName !== ""
                ? n.clientLastName.length === clientLastName ||
                n.clientLastName.includes(clientLastName) ||
                n.clientLastName.includes(clientLastName.toLowerCase())
                : true
            )
            .forEach((order) => {
              if (!filteredClientsName.includes(order.clientLastName)) {
                filteredClientsName.push(order.clientLastName);
                const filtered = data.filter(
                  (o) => o.clientLastName === order.clientLastName
                );
                clients.push({
                  id: uuidv4(),
                  firstName: order.clientFirstName,
                  lastName: order.clientLastName,
                  totalOrders: filtered.length,
                });
              }
            });
        }
      });
    await firestore
      .collection("orders")
      .where("teamId", "==", userData.teamId)
      .where("clientFirstName", "==", capitalize(clientFirstName))
      .get()
      .then((qSnap) => {
        if (!qSnap.empty) {
          let data = qSnap.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
          let filteredClientsName = [];

          data
            .filter((n) =>
              clientLastName !== ""
                ? n.clientLastName.length === clientLastName ||
                n.clientLastName.includes(clientLastName) ||
                n.clientLastName.includes(clientLastName.toLowerCase())
                : true
            )
            .forEach((order) => {
              if (!filteredClientsName.includes(order.clientLastName)) {
                filteredClientsName.push(order.clientLastName);
                const filtered = data.filter(
                  (o) => o.clientLastName === order.clientLastName
                );
                clients.push({
                  id: uuidv4(),
                  firstName: order.clientFirstName,
                  lastName: order.clientLastName,
                  totalOrders: filtered.length,
                });
              }
            });
        }
      });
    return clients;
  };

  useEffect(() => {
    if (signedIn && userData && userData.teamId && clientFirstName !== "") {
      getClientsDetails().then((clients) => setSimilarClients(clients));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signedIn, userData, clientFirstName, clientLastName]);

  // useEffect(() => {
  //   if(signedIn && userData && order && order.orderID && !order.orderNumber){
  //     goToPayments(false);
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [order])

  const goToPayments = async (redirect = true) => {
    const now = new Date();

    if(!order.orderID || !order.languageFrom || !order.languageTo){
      showNotification('Error', "Order data is missing. Please, try again. If it persists, contact support.", 'error');
      return;
    }

    try{
      redirect && setContinueButton("Continuing...");

      const fName = userData.firstName ? userData.firstName : userData.name;
      const lName = userData.lastName ? userData.lastName : "";
      const FullName = userData.name
        ? userData.name
        : `${userData.firstName} ${userData.lastName}`;
      const Email = userData.email.toLowerCase();

      if (emailRegex.test(Email)) {
        let orderNumber = 0;

        if (!order.orderNumber) {
          await getCounter("order").then((number) => {
              orderNumber = parseInt(number, 10);
            })
            .catch((error) => {
              //console.log(error);
            });
          if (orderNumber === 0) {
            showNotification(
              "Error",
              "An error ocurred while processing the request. Please, try again. If it persists, contact support.",
              "error"
            );
            setContinueButton("Continue to Payment");
            return false;
          }
        }

        const addressID = !newAddressModal ? selectedMyAddress : uuidv4();
        const country = newAddressModal ? hardCopyCountry.label : selectedMyCountry;
        const method = newAddressModal ? hardCopyMethod : selectedMyMethod;

        const calculatedTotalPrice =
          getTotal(
            order,
            false,
            false,
            notarization,
            expedited,
            expeditedPlus,
            hardCopy,
            country,
            method,
            hardCopyRequireSignature,
            getExpeditedFeeOption(userData, teamData)
          ) || 0;

        const hardCopyExtra = {
          id: addressID,
          newAddress: newAddressModal,
          country: country,
          countryIsoCode: hardCopyCountry.value,
          method,
          requireSignature: hardCopyRequireSignature,
          saveAddress,
          addressName,
          firstName: hardCopyFirstName,
          lastName: hardCopyLastName,
          recipient: `${hardCopyFirstName} ${hardCopyLastName}`,
          region: hardCopyState.label,
          regionIsoCode: hardCopyState.value,
          city: hardCopyCity.label,
          cityIsoCode: hardCopyCity.value,
          zipCode: hardCopyZipCode,
          street: hardCopyStreet,
          apartment: hardCopyApartment,
        };
        const data = {
          orderNumber:  order.orderNumber ? order.orderNumber : orderNumber,
          userID: signedIn ? auth.currentUser.uid : "",
          teamId: signedIn ? userData.teamId || "" : "",
          email: signedIn
            ? userData?.email || auth.currentUser.email
            : Email,
          name: FullName,
          timestamp: now.getTime(),
          status: "created",
          totalPrice: calculatedTotalPrice,
          discount: order.discount || 0,
          discountApplied: order.discount && order.discount > 0,
          firstName: fName,
          lastName: lName,
          certified: order.certified,
          languageFrom: order.languageFrom,
          languageTo: order.languageTo,
          notarization: notarization,
          notarizationStatus: notarization ? "pending" : null,
          expedited: expedited,
          expeditedPlus: expeditedPlus,
          hardCopy: hardCopy,
          hardCopyStatus: hardCopy ? "pending" : null,
          hardCopyExtra: hardCopy ? hardCopyExtra : null,
          pagesCount: order.pagesCount ? order.pagesCount : 0,
          wordCount: 0,
          files: order.files.map((file) => ({
            name: file.name,
            ref: file.ref,
            url: file.url,
            type: file.type,
            size: file.size,
            format: file.format,
            timestamp: file.timestamp,
          })),
          notified: false,
          userNotes: "",
          type: order.type,
          generalNotes: order.generalNotes,
          notes: order.generalNotes,
          clientFirstName: clientFirstName,
          clientLastName: clientLastName,
          expeditedServiceOption: getExpeditedFeeOption(userData, teamData),
        };
        const cleanData = removeUndefinedFields(data);

        localStorage.setItem(
          "order",
          JSON.stringify({
            ...order,
            orderNumber: order.orderNumber ? order.orderNumber : orderNumber,
            firstName: fName,
            lastName: lName,
            name: FullName,
            email: userData.email.toLowerCase(),
            expeditedServiceOption: getExpeditedFeeOption(userData, teamData),
            clientFirstName: clientFirstName,
            clientLastName: clientLastName,
            totalPrice: calculatedTotalPrice, // Ensure totalPrice is valid
            files: JSON.stringify(
              order.files
                ?.filter((f) => f.ref && f.url && f.status === "complete")
                .map((file) => ({
                  name: file.name,
                  ref: file.ref,
                  url: file.url,
                  type: "source",
                  size: file.file ? file.file.size : file.size,
                  format: file.file ? file.file.type : file.format,
                  status: "complete",
                  progress: 100,
                  timestamp: file.timestamp,
                }))
            ),
            optionsSet: true,
            notarization,
            expedited,
            expeditedPlus,
            hardCopy,
            hardCopyExtra: hardCopy
              ? {
                  id: addressID,
                  newAddress: newAddressModal,
                  country: country,
                  countryIsoCode: hardCopyCountry.value,
                  method,
                  requireSignature: hardCopyRequireSignature,
                  saveAddress,
                  addressName,
                  firstName: hardCopyFirstName,
                  lastName: hardCopyLastName,
                  recipient: `${hardCopyFirstName} ${hardCopyLastName}`,
                  region: hardCopyState.label,
                  regionIsoCode: hardCopyState.value,
                  city: hardCopyCity.label,
                  cityIsoCode: hardCopyCity.value,
                  zipCode: hardCopyZipCode,
                  street: hardCopyStreet,
                  apartment: hardCopyApartment,
                }
              : null,
          })
        );
  
        setOrder((o) => ({
          ...o,
          orderNumber: order.orderNumber ? order.orderNumber : orderNumber,
          firstName: fName,
          lastName: lName,
          email: Email,
          name: FullName,
          expeditedServiceOption: getExpeditedFeeOption(userData, teamData),
          clientFirstName,
          clientLastName,
          totalPrice: calculatedTotalPrice, // Ensure totalPrice is valid
          optionsSet: true,
          notarization,
          expedited,
          expeditedPlus,
          hardCopy,
          hardCopyExtra: hardCopy
            ? {
                id: addressID,
                newAddress: newAddressModal,
                country: country,
                countryIsoCode: hardCopyCountry.value,
                method,
                requireSignature: hardCopyRequireSignature,
                saveAddress,
                addressName,
                firstName: hardCopyFirstName,
                lastName: hardCopyLastName,
                recipient: `${hardCopyFirstName} ${hardCopyLastName}`,
                region: hardCopyState.label,
                regionIsoCode: hardCopyState.value,
                city: hardCopyCity.label,
                cityIsoCode: hardCopyCity.value,
                zipCode: hardCopyZipCode,
                street: hardCopyStreet,
                apartment: hardCopyApartment,
              }
            : null,
        }));

        firestore
          .collection("orders")
          .doc(order.orderID)
          .set(cleanData)
          .then(() => {
            setContinueButton("Continue to Payment");
            redirect && transitionTo("/order/payment");
          })
          .catch((error) => {
            setContinueButton("Continue to Payment");
            showNotification(
              "Error",
              "An error ocurred while placing the order. Please, try again.",
              "error"
            );
          });
      } else {
        setContinueButton("Continue to Payment");
        showNotification(
          "Invalid Email",
          "The email address is invalid. Please, try again.",
          "error"
        );
      }
    }catch(error){
      console.log(error);
      setContinueButton('Continue to Payment');
      showNotification('Error', error.message, "error")
    }
  };

  const removeUndefinedFields = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map(removeUndefinedFields);
    } else if (obj !== null && typeof obj === "object") {
      return Object.fromEntries(
        Object.entries(obj)
          .filter(([_, v]) => v !== undefined) // Remove undefined fields
          .map(([k, v]) => [k, removeUndefinedFields(v)]) // Recursively clean nested objects
      );
    }
    return obj;
  };

  const handleContinueToPayment = async () => {
    setContinueButton("Continuing...");
    
    try{
      if (hardCopy && !newAddressModal && selectedMyAddress === "") {
        showNotification(
          "Error",
          "Please select an address or add a new address.",
          "error"
        );
        return false;
      }

      const addressID = !newAddressModal ? selectedMyAddress : uuidv4();
      const country = newAddressModal ? hardCopyCountry.label : selectedMyCountry;
      const method = newAddressModal ? hardCopyMethod : selectedMyMethod;

      // Ensure totalPrice is correctly calculated
      const calculatedTotalPrice =
        getTotal(
          order,
          false,
          false,
          notarization,
          expedited,
          expeditedPlus,
          hardCopy,
          country,
          method,
          hardCopyRequireSignature,
          getExpeditedFeeOption(userData, teamData)
        ) || 0; // Default to 0 if undefined

         localStorage.setItem(
           "order",
           JSON.stringify({
             ...order,
             expeditedServiceOption: getExpeditedFeeOption(userData, teamData),
             clientFirstName: clientFirstName,
             clientLastName: clientLastName,
             totalPrice: calculatedTotalPrice, // Ensure totalPrice is valid
             files: JSON.stringify(
               order.files
                 ?.filter((f) => f.ref && f.url && f.status === "complete")
                 .map((file) => ({
                   name: file.name,
                   ref: file.ref,
                   url: file.url,
                   type: "source",
                   size: file.file ? file.file.size : file.size,
                   format: file.file ? file.file.type : file.format,
                   status: "complete",
                   progress: 100,
                   timestamp: file.timestamp,
                 }))
             ),
             optionsSet: true,
             notarization,
             expedited,
             expeditedPlus,
             hardCopy,
             hardCopyExtra: hardCopy
               ? {
                   id: addressID,
                   newAddress: newAddressModal,
                   country: country,
                   countryIsoCode: hardCopyCountry.value,
                   method,
                   requireSignature: hardCopyRequireSignature,
                   saveAddress,
                   addressName,
                   firstName: hardCopyFirstName,
                   lastName: hardCopyLastName,
                   recipient: `${hardCopyFirstName} ${hardCopyLastName}`,
                   region: hardCopyState.label,
                   regionIsoCode: hardCopyState.value,
                   city: hardCopyCity.label,
                   cityIsoCode: hardCopyCity.value,
                   zipCode: hardCopyZipCode,
                   street: hardCopyStreet,
                   apartment: hardCopyApartment,
                 }
               : null,
           })
         );
   
         setOrder((o) => ({
           ...o,
           expeditedServiceOption: getExpeditedFeeOption(userData, teamData),
           clientFirstName,
           clientLastName,
           totalPrice: calculatedTotalPrice, // Ensure totalPrice is valid
           optionsSet: true,
           notarization,
           expedited,
           expeditedPlus,
           hardCopy,
           hardCopyExtra: hardCopy
             ? {
                 id: addressID,
                 newAddress: newAddressModal,
                 country: country,
                 countryIsoCode: hardCopyCountry.value,
                 method,
                 requireSignature: hardCopyRequireSignature,
                 saveAddress,
                 addressName,
                 firstName: hardCopyFirstName,
                 lastName: hardCopyLastName,
                 recipient: `${hardCopyFirstName} ${hardCopyLastName}`,
                 region: hardCopyState.label,
                 regionIsoCode: hardCopyState.value,
                 city: hardCopyCity.label,
                 cityIsoCode: hardCopyCity.value,
                 zipCode: hardCopyZipCode,
                 street: hardCopyStreet,
                 apartment: hardCopyApartment,
               }
             : null,
         }));

      if (signedIn && userData) {
        // Wait for address logic to complete before calling goToPayments()
        await goToPayments();
        // transitionTo("/order/payment");
      } else {
        transitionTo("/order/contact");
      }
    }catch (error) {
      console.log(error);
    }finally{
      setContinueButton(signedIn ? "Continue to Payment" : "Continue to Contact");
    }
  };

  const getLanguage = (language) => {
    if (languages.find((lang) => lang.value === language)) {
      return languages.find((lang) => lang.value === language).label;
    } else {
      return "";
    }
  };

  const triggerContinue = () => {
    if (
      !(
        !order.type ||
        order.languageFrom === "" ||
        checkForHardCopyFields() ||
        (hardCopy && saveAddress && addressName === "")
      )
    ) {
      handleContinueToPayment();
    }
  };

  useEnterKey(() => triggerContinue());

  const phoneScreen =
    windowSize.orientation === "portrait" && windowSize.width <= 767;

  const getServicesTotal = () => {
    return (
      0 +
      (notarization ? 34.9 : 0) +
      (expeditedPlus || expedited
        ? getExpedited(order, false, expeditedPlus, expedited, false, getExpeditedFeeOption(userData, teamData))
        : 0) +
      (hardCopy
        ? getHardCopyPrice(
          newAddressModal ? hardCopyCountry : selectedMyCountry,
          newAddressModal ? hardCopyMethod : selectedMyMethod,
          false
        )
        : 0) +
      (hardCopy && hardCopyRequireSignature ? 4.99 : 0)
    );
  };

  const handleFocusDelivery = (isFocused) => {
    if (newAddressModal) {
      setNewDeliveryFocus({ delivery: isFocused, country: false });
    } else {
      setMyDeliveryFocus({ delivery: isFocused, country: false });
    }
  };

  const checkForHardCopyFields = () => {
    if (hardCopy) {
      if (
        newAddressModal
          ? hardCopyCountry === "" ||
          hardCopyMethod === "" ||
          hardCopyFirstName === "" ||
          hardCopyState === "" ||
          hardCopyCity === "" ||
          hardCopyZipCode === "" ||
          hardCopyStreet === ""
          : selectedMyAddress === "" ||
          selectedMyCountry === "" ||
          selectedMyMethod === ""
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const getHardCopyTotal = () => {
    return (
      (["United States", "Puerto Rico", "U.S. Virgin Islands"].includes(
        hardCopyCountry.label
      )
        ? hardCopyMethod === "priority"
          ? 19.95
          : 37.95
        : hardCopyMethod === "priority"
          ? 49.95
          : 78.95) + (hardCopyRequireSignature ? 4.99 : 0)
    );
  };

  const getExpeditedPlusAvaliblity = () => {
    const date = new Date();
    const time = date
      .toLocaleString("en-US", { timeZone: "America/New_York" })
      .split(",")
      .pop();
    const day = time.split(" ").pop() === "AM" ? true : false;
    const hour = time.split(":")[0];

    // eslint-disable-next-line eqeqeq
    if ((!day && hour >= 5) || (day && (hour < 8 || hour == 12))) {
      return false;
    } else {
      return true;
    }
  };

  const getExpeditedPlusByLanguage = () => {
    if (
      expeditedPlusLanguages.includes(order.languageFrom) &&
      expeditedPlusLanguages.includes(order.languageTo)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleExpedited = () => {
    setExpeditedPlus(false);
    setExpedited((e) => !e);
  };

  const handleExpeditedPlus = () => {
    setExpedited(false);
    setExpeditedPlus((e) => !e);
  };

  const getFullAddress = (address) => {
    const first = address.firstName ? address.firstName : address.recipient;
    const last =
      address.firstName && address.lastName ? " " + address.lastName : "";

    const name = first + last;

    return (
      name +
      ", " +
      address.country +
      ", " +
      address.region +
      ", " +
      address.city +
      ", " +
      address.zipCode +
      ", " +
      address.street +
      ", " +
      address.apartment
    );
  };

  const handleEditAddress = (address) => {
    setEditAddress(address.id);
    setEditAddressIconSelected("");

    setEditAddressName(address.addressName ? address.addressName : address.recipient || "");
    setEditCountry({ label: address.country, value: address.countryIsoCode } || "");
    setEditFirstName(address.firstName ? address.firstName : address.recipient || "");
    setEditLastName(address.lastName ? address.lastName : "");
    setEditState({ label: address.region, value: address.regionIsoCode } || "");
    setEditCity({ label: address.city, value: address.cityIsoCode } || "");
    setEditZipCode(address.zipCode || "");
    setEditStreet(address.street || "");
    setEditApartment(address.apartment || "");
  };

  const handleDeleteAddress = (address, isTeamAddress = true, notify = true) => {
     setDeleteBtnText("Deleting...");
     const newAddresses = isTeamAddress ? teamData && teamData.shipping.length > 0 ? teamData.shipping.filter(a => a.id !== address.id) : []
     : userData.shipping && userData.shipping.length > 0 ? userData.shipping.filter(a => a.id !== address.id) : [];
 
     setEditAddressIconSelected("");
     setEditAddress("");
 
     firestore.collection(isTeamAddress ? "teams":"users").doc(isTeamAddress ? userData.teamId : userData.id).update({
       shipping: newAddresses
     }).then(() => {
       setDeleteModalAddress(null);
       notify && showNotification('Success', "Address deleted successfully.", 'success');
     }).catch(() => {
       showNotification('Error', "An error ocurred while processing the request. Please, try again. If it persists, contact support.", 'error');
     }).finally(() => {
       setDeleteBtnText("Delete Address");
     })
 
   }

  const handleUpdateAddress = (address, isTeamAddress = true) => {
       setSaveEditsBtnText("Saving...");
   
       const newEditedAddress = {
         addressName: editAddressName,
         firstName: editFirstName,
         lastName: editLastName,
         recipient: editFirstName + " " + editLastName,
         country: editCountry.label,
         countryIsoCode: editCountry.value,
         city: editCity.label,
         cityIsoCode: editCity.value,
         region: editState.label,
         regionIsoCode: editState.value,
         zipCode: editZipCode,
         street: editStreet,
         apartment: editApartment || "",
         id: address.id || uuidv4(),
         default: address.default || false
       }
   
       let newAddresses = [];
   
   
       if (address === "new" ) {
         if(isTeamAddress && teamData && teamData.shipping && teamData.shipping.length > 0){
           newAddresses = [...teamData.shipping, newEditedAddress];
         }else if(!teamData && userData.shipping && userData.shipping.length > 0){
         newAddresses = [...userData.shipping, newEditedAddress];
         }else{
           newAddresses = [newEditedAddress];
         }
       } else {
         newAddresses = isTeamAddress ? teamData.shipping && teamData.shipping.length > 0 ? teamData.shipping.map(a => a.id === address.id ? newEditedAddress : a) : [] : 
         userData.shipping.length > 0 ? userData.shipping.map(a => a.id === address.id ? newEditedAddress : a) : [];
       }
   
       firestore.collection((isTeamAddress && address=== "new") || isTeamAddress ? "teams" :"users")
       .doc((isTeamAddress && address=== "new") || isTeamAddress ? userData.teamId : userData.id).update({
         shipping: newAddresses
       }).then(() => {
         setSelectedMyAddress("");
         setEditAddressIconSelected("");
         setEditAddress("");
         setSaveEditsBtnText("Save");
         showNotification('Success', "Address updated successfully.", 'success');
       }).catch(() => {
         setSaveEditsBtnText("Save");
         showNotification('Error', "An error ocurred while processing the request. Please, try again. If it persists, contact support.", 'error');
       })
   
    }

  const handleMyAddressClick = () => {
    setNewAddressModal(false);
    setEditAddress("");
    setEditAddressIconSelected("");
    setNewDeliveryFocus({ delivery: false, country: false });
    setMyDeliveryFocus({ delivery: false, country: false });
  };

  const handleNewAddressClick = () => {
    setNewAddressModal(true);
    setEditAddress("");
    setEditAddressIconSelected("");
    setNewDeliveryFocus({ delivery: false, country: false });
    setMyDeliveryFocus({ delivery: false, country: false });
  };

  const handleClientSelect = (client) => {
    setClientFirstName(client.firstName);
    setClientLastName(client.lastName);
  };

  const handleNotrization = () => {
    setNotarization((n) => !n);
  };

  return (
    <>
      <TopBar />

      {deleteModalAddress && <PopUpModal title={"Delete Address"} backBtnText="Back to Shipping Addresses" subText="Are you sure you want to delete this address?" text={deleteModalAddress.addressName} btnText={deleteBtnText}
        iconBgColor="#FFF6EA" deleteBtn={true} showClose onClose={() => setDeleteModalAddress(null)} onClick={() => { handleDeleteAddress(deleteModalAddress, userData.teamId ? true : false) }} onBackClick={() => setDeleteModalAddress(null)} disableBtn={deleteBtnText === "Deleting..."}>
        <ADDRESS />
      </PopUpModal>}

      <div className="mainOrderContainer">
        <div className="mainOrderHeader">
          <LogoAuthNavbar isAuth={signedIn} showButtons={false} />
        </div>

        <div className="mainOrderPageContainer">
          <div className="mainOrderPageContainerOptions">
            <CreateOrderNav title="3. Services" stage={3} />
            <div></div>
          </div>
        </div>
        <div className="mainOrderPageContainer">
          <div className="mainOrderPageContainerOptions">
            <div id="mainPrimary" className="mainOrderPrimaryContent">
              <div className="quotePrimaryOptionsWrapper">
                <h3 className="quotePrimaryTitle">
                  Which optional services do you need?
                </h3>
                {order.certified ? (
                  <div
                    className="quoteOptionalContainer firstQuoteOptionalContainer"
                    onClick={() => handleNotrization()}
                    style={{
                      borderColor: notarization ? "#12ABBF" : "#E6E7E9",
                    }}
                  >
                    <div className="orderContentContainer">
                      <div className="orderIconWrapper">
                        <NOTRY className="icon" />
                      </div>
                      <div className="quoteOptionalTitleRow">
                        <div className="orderDetailsContainer">
                          <h5 className="orderPrimaryOptionTitle">
                            Notarization
                          </h5>
                          <p className="quotePrimaryOptionText">
                            Stamp and signature authenticating the translation
                            certification. Valid in all 50 states.
                          </p>
                        </div>
                        <div className="orderOptionalExtraContainer">
                          <p className="orderOptionalPrice">$34.90</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                <div
                  className={`quoteOptionalContainer ${order.certified ? "": "mt-4"}`}
                  onClick={() => handleExpedited()}
                  style={{ borderColor: expedited ? "#12ABBF" : "#E6E7E9" }}
                >
                  <div className="orderContentContainer">
                    <div className="orderIconWrapper">
                      <EXPEDITED className="icon" />
                    </div>
                    <div className="quoteOptionalTitleRow">
                      <div className={`orderDetailsContainer`}>
                        <h5 className={`orderPrimaryOptionTitle`}>
                          Expedited Turnaround 
                          {getExpeditedFreeOrders(userData,teamData) > 0 && 
                          <span className="text-[#9A9FA7]">{" ("+ getExpeditedFreeOrders(userData, teamData) +  " free orders left) "}</span>}
                        </h5>
                        <p className="quotePrimaryOptionText">
                          Your order will be prioritized and turnaround time for
                          digital delivery reduced by 50%.
                        </p>
                      </div>
                      <div className="orderOptionalExtraContainer">
                        <p className="orderOptionalPrice">{getExpeditedPriceLabel(false, userData, teamData)}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="quoteOptionalContainer"
                  onClick={() => {
                    getExpeditedPlusAvaliblity() &&
                      getExpeditedPlusByLanguage() &&
                      handleExpeditedPlus();
                  }}
                  style={{
                    borderColor:
                      getExpeditedPlusAvaliblity() &&
                        getExpeditedPlusByLanguage() &&
                        expeditedPlus
                        ? "#12ABBF"
                        : "#E6E7E9",
                    opacity:
                      getExpeditedPlusAvaliblity() &&
                        getExpeditedPlusByLanguage()
                        ? 1
                        : 0.5,
                    cursor:
                      getExpeditedPlusAvaliblity() &&
                        getExpeditedPlusByLanguage()
                        ? "pointer"
                        : "default",
                  }}
                >
                  <div className="orderContentContainer">
                    <div className="orderIconWrapper">
                      <EXPEDITEDPLUS className="icon" />
                    </div>
                    <div className="quoteOptionalTitleRow">
                      <div className="orderDetailsContainer">
                        <h5 className="orderPrimaryOptionTitle">
                          Expedited Turnaround Plus
                          {getExpeditedFreeOrders(userData,teamData) > 0 && 
                          <span className="text-[#9A9FA7]">{" ("+ getExpeditedFreeOrders(userData, teamData) +  " free orders left) "}</span>}
                        </h5>
                        <p className="quotePrimaryOptionText">
                          Your order will be prioritized and turnaround time for
                          digital delivery reduced by 83.33%.
                        </p>
                        {!(
                          getExpeditedPlusAvaliblity() &&
                          getExpeditedPlusByLanguage()
                        ) && (
                            <div className="expeditedPlusErrorWrap">
                              <p className="expeditedPlusErrorText">
                                {!getExpeditedPlusAvaliblity() &&
                                  getExpeditedPlusByLanguage()
                                  ? "Unavailable after 5 PM to 8 AM EST"
                                  : getExpeditedPlusAvaliblity() &&
                                    !getExpeditedPlusByLanguage()
                                    ? "Unavailable for non-Latin languages."
                                    : "Unavailable after 5 PM to 8 AM EST and for non-Latin languages."}
                              </p>
                            </div>
                          )}
                      </div>
                      <div className="orderOptionalExtraContainer">
                        <p className="orderOptionalPrice">{getExpeditedPriceLabel(true, userData, teamData)}</p>
                      </div>
                    </div>
                  </div>
                </div>
                {order.certified ? (
                  <div
                    className="quoteOptionalContainer"
                    style={{ borderColor: hardCopy ? "#12ABBF" : "#E6E7E9" }}
                  >
                    <div
                      className="orderContentContainer"
                      onClick={() => setHardCopy((n) => !n)}
                    >
                      <div className="orderIconWrapper">
                        <HARDCOPY className="icon" />
                      </div>
                      <div className="quoteOptionalTitleRow">
                        <div className="orderDetailsContainer">
                          <h5 className="orderPrimaryOptionTitle">
                            Mail Hard Copy
                          </h5>
                          <p className="quotePrimaryOptionText">
                            Original translation with wet ink signature(s)
                            shipped via USPS Priority or Express mail.
                          </p>
                        </div>
                        <div className="orderOptionalExtraContainer">
                          <p className="orderOptionalPrice">
                            {hardCopy &&
                              hardCopyCountry !== "" &&
                              hardCopyMethod !== "" &&
                              formatTotal(getHardCopyTotal())}
                          </p>
                        </div>
                      </div>
                    </div>

                    {hardCopy &&
                    signedIn &&
                    userData &&
                    ((userData.teamId && teamData && teamData.shipping &&
                    teamData.shipping.length > 0) ||
                    (userData.shipping &&
                    userData.shipping.length > 0))? (
                      <div className="hardCopyAddressTabWrap">
                        <div
                          className="hardCopyAddressTab"
                          onClick={handleMyAddressClick}
                        >
                          <div
                            className="hardCopyAddressTabText"
                            style={{
                              borderBottomWidth: !newAddressModal ? "2px" : 0,
                            }}
                          >
                            My Address
                          </div>
                        </div>
                        <div
                          className="hardCopyAddressTab"
                          onClick={handleNewAddressClick}
                        >
                          <div
                            className="hardCopyAddressTabText"
                            style={{
                              borderBottomWidth: newAddressModal ? "2px" : 0,
                            }}
                          >
                            New Address
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {hardCopy ? (
                      signedIn &&
                      userData &&
                      !newAddressModal ? (
                        <>
                          {userData.teamId && teamData && teamData.shipping && teamData.shipping.length > 0 &&
                          teamData.shipping.map((address, i) => (
                            <div
                              key={address.id}
                              className="hardCopyAddressContainer"
                              style={{
                                borderColor:
                                  selectedMyAddress === address.id
                                    ? "#12ABBF"
                                    : "#E6E7E9",
                              }}
                            >
                              <div className="quoteOptionalTitleRow">
                                <div
                                  className="hardCopyAddressDetails"
                                  onClick={() =>
                                    setSelectedMyAddress(address.id)
                                  }
                                >
                                  <h6 className="hardCopyAddressTitle">
                                    {address.addressName
                                      ? address.addressName
                                      : address.recipient}{" "}
                                    <span>
                                      {address.default && "(primary)"}
                                    </span>
                                  </h6>
                                  <p className="hardCopyAddressText">
                                    {getFullAddress(address)}
                                  </p>
                                </div>
                                <div
                                  className="hardCopyAddressIconWrap"
                                >
                                  {editAddressIconSelected === i ? (
                                    <MORESELECTED
                                      className="hardCopyAddressIcon"
                                      onClick={(e) => {
                                        e.stopPropagation(); 
                                        setEditAddressIconSelected("")
                                      }
                                      }
                                    />
                                  ) : (
                                    <MORE
                                      className="hardCopyAddressIcon"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setEditAddressIconSelected(i);
                                      }}
                                    />
                                  )}
                                  {editAddressIconSelected === i && (
                                    <div className="hardCopyAddressEditWrap">
                                      <div
                                        className="hardCopyAddressEdit"
                                        onClick={() =>
                                          handleEditAddress(address)
                                        }
                                      >
                                        Edit
                                      </div>
                                      <div
                                        className="hardCopyAddressEdit"
                                        onClick={() => { setDeleteModalAddress(address); setEditAddress(""); setEditAddressIconSelected("") }}
                                      >
                                        Delete
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>

                              {editAddress === address.id && (
                                <div className="editInputsContainer">
                                  <div className="quoteDetailsInputsContainer">
                                    <FormTextInput
                                      placeholder={"Address Name"}
                                      value={editAddressName}
                                      onChange={setEditAddressName}
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                     <SelectSearch
                                      placeholder="Select Country"
                                      value={editCountry.value}
                                      setValue={(val) => setEditCountry(countries.find(c => c.value === val))}
                                      list={countries}
                                      activeDropdown={activeDropdown}
                                        setActiveDropdown={setActiveDropdown}
                                        dropdownId="country"
                                      />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <FormTextInput
                                      placeholder={"First Name"}
                                      value={editFirstName}
                                      onChange={setEditFirstName}
                                    />
                                    <FormTextInput
                                      placeholder={"Last Name"}
                                      value={editLastName}
                                      onChange={setEditLastName}
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <SelectSearch
                                    placeholder="Select State"
                                    value={editState ? editState.value : ""}
                                    setValue={(val) => setEditState(getStates(editCountry.value).find(s => s.value === val))}
                                    list={getStates(editCountry.value)}
                                    activeDropdown={activeDropdown}
                                    setActiveDropdown={setActiveDropdown}
                                    dropdownId="state"
                                    disabled={!editCountry.value}
                                    />
                                    <SelectSearch
                                    placeholder="Select City"
                                    value={editCity ? editCity.value : ""}
                                    setValue={(val) => setEditCity(getCities(editState.value,editCountry.value).find(c => c.value === val))}
                                    list={getCities(editState.value,editCountry.value)}
                                    activeDropdown={activeDropdown}
                                    setActiveDropdown={setActiveDropdown}
                                    dropdownId="city"
                                    disabled={!editCountry.value || !editState.value}
                                    />
                                    <FormTextInput
                                      placeholder={"ZIP code"}
                                      value={editZipCode}
                                      onChange={setEditZipCode}
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <FormTextInput
                                      placeholder={"Street/Address"}
                                      value={editStreet}
                                      onChange={setEditStreet}
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <FormTextInput
                                      placeholder={"Apartment, suite, etc."}
                                      value={editApartment}
                                      onChange={setEditApartment}
                                    />
                                  </div>
                                  <div className="editInputBtnContainer">
                                    <NewButton
                                      onClick={() =>
                                        handleUpdateAddress(address, true)
                                      }
                                      disabled={
                                        saveEditsBtnText === "Saving..."
                                      }
                                      text={saveEditsBtnText}
                                      width="150px"
                                    />
                                    <NewButton
                                      onClick={() => setEditAddress("")}
                                      text={"Cancel"}
                                      icon={false}
                                      whiteBtn
                                      back={true}
                                      width="150px"
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                          {userData.shipping && userData.shipping.length > 0 &&
                          userData.shipping.map((address, i) => (
                            <div
                              key={address.id}
                              className="hardCopyAddressContainer"
                              style={{
                                borderColor:
                                  selectedMyAddress === address.id
                                    ? "#12ABBF"
                                    : "#E6E7E9",
                              }}
                            >
                              <div className="quoteOptionalTitleRow">
                                <div
                                  className="hardCopyAddressDetails"
                                  onClick={() =>
                                    setSelectedMyAddress(address.id)
                                  }
                                >
                                  <h6 className="hardCopyAddressTitle">
                                    {address.addressName
                                      ? address.addressName
                                      : address.recipient}{" "}
                                    <span>
                                      {address.default && "(primary)"}
                                    </span>
                                  </h6>
                                  <p className="hardCopyAddressText">
                                    {getFullAddress(address)}
                                  </p>
                                </div>
                                <div
                                  className="hardCopyAddressIconWrap"
                                  onMouseOver={() =>
                                    setEditAddressIconSelected(i)
                                  }
                                  onMouseLeave={() =>
                                    setEditAddressIconSelected("")
                                  }
                                >
                                  {editAddressIconSelected === i ? (
                                    <MORESELECTED
                                      className="hardCopyAddressIcon"
                                      onClick={() =>
                                        setEditAddressIconSelected("")
                                      }
                                    />
                                  ) : (
                                    <MORE
                                      className="hardCopyAddressIcon"
                                      onClick={() => {
                                        setEditAddressIconSelected(i);
                                      }}
                                    />
                                  )}
                                  {editAddressIconSelected === i && (
                                    <div className="hardCopyAddressEditWrap">
                                      <div
                                        className="hardCopyAddressEdit"
                                        onClick={() =>
                                          handleEditAddress(address)
                                        }
                                      >
                                        Edit
                                      </div>
                                      <div
                                        className="hardCopyAddressEdit"
                                        onClick={() => { setDeleteModalAddress(address); setEditAddress(""); setEditAddressIconSelected("") }}
                                      >
                                        Delete
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>

                              {editAddress === address.id && (
                                <div className="editInputsContainer">
                                  <div className="quoteDetailsInputsContainer">
                                    <FormTextInput
                                      placeholder={"Address Name"}
                                      value={editAddressName}
                                      onChange={setEditAddressName}
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <SelectSearch
                                      placeholder="Select Country"
                                      value={editCountry.value}
                                      setValue={(val) => setEditCountry(countries.find(c => c.value === val))}
                                      list={countries}
                                      activeDropdown={activeDropdown}
                                      setActiveDropdown={setActiveDropdown}
                                      dropdownId="country"
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <FormTextInput
                                      placeholder={"First Name"}
                                      value={editFirstName}
                                      onChange={setEditFirstName}
                                    />
                                    <FormTextInput
                                      placeholder={"Last Name"}
                                      value={editLastName}
                                      onChange={setEditLastName}
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                   <SelectSearch
                                    placeholder="Select State"
                                    value={editState ? editState.value : ""}
                                    setValue={(val) => setEditState(getStates(editCountry.value).find(s => s.value === val))}
                                    list={getStates(editCountry.value)}
                                    activeDropdown={activeDropdown}
                                    setActiveDropdown={setActiveDropdown}
                                    dropdownId="state"
                                    disabled={!editCountry.value}
                                  />
                                  <SelectSearch
                                    placeholder="Select City"
                                    value={editCity ? editCity.value : ""}
                                    setValue={(val) => setEditCity(getCities(editState.value,editCountry.value).find(c => c.value === val))}
                                    list={getCities(editState.value,editCountry.value)}
                                    activeDropdown={activeDropdown}
                                    setActiveDropdown={setActiveDropdown}
                                    dropdownId="city"
                                    disabled={!editCountry.value || !editState.value}
                                  />
                                    <FormTextInput
                                      placeholder={"ZIP code"}
                                      value={editZipCode}
                                      onChange={setEditZipCode}
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <FormTextInput
                                      placeholder={"Street/Address"}
                                      value={editStreet}
                                      onChange={setEditStreet}
                                    />
                                  </div>
                                  <div className="quoteDetailsInputsContainer">
                                    <FormTextInput
                                      placeholder={"Apartment, suite, etc."}
                                      value={editApartment}
                                      onChange={setEditApartment}
                                    />
                                  </div>
                                  <div className="editInputBtnContainer">
                                    <NewButton
                                      onClick={() =>
                                        handleUpdateAddress(address, false)
                                      }
                                      disabled={
                                        saveEditsBtnText === "Saving..."
                                      }
                                      text={saveEditsBtnText}
                                      width="150px"
                                    />
                                    <NewButton
                                      onClick={() => setEditAddress("")}
                                      text={"Cancel"}
                                      icon={false}
                                      whiteBtn
                                      back={true}
                                      width="150px"
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                          <div className="quoteDetailsInputsContainer">
                            <div className="quoteDetailsSelectContainer sm:w-1/2 w-full">
                              <SearchSelect
                                list={
                                  selectedMyCountry
                                    ? [
                                      "United States",
                                      "Puerto Rico",
                                      "U.S. Virgin Islands",
                                    ].includes(selectedMyCountry)
                                      ? USPriorDelivery
                                      : otherCitiesDelivery
                                    : []
                                }
                                placeholder="Delivery"
                                value={selectedMyMethod}
                                focus={myDeliveryFocus.delivery}
                                setValue={setSelectedMyMethod}
                                setFocus={handleFocusDelivery}
                              />
                            </div>
                          </div>

                          <div
                            className="hardCopyCheckboxLine"
                            onClick={() =>
                              setHardCopyRequireSignature((hc) => !hc)
                            }
                          >
                            <div
                              className={`${hardCopyRequireSignature && "hardCopyChecked"
                                } hardCopyCheckbox`}
                            >
                              <Check
                                className="hardCopyCheck"
                                style={{
                                  opacity: hardCopyRequireSignature ? 1 : 0,
                                }}
                              />
                            </div>
                            <p className="hardCopyCheckboxText">
                              Require signature for delivery $4.99
                            </p>
                          </div>
                        </>
                      ) : (
                        <div className="editInputsContainer">
                          {/* <div className="hardCopyLineSeparator" /> */}
                          <div className="grid sm:grid-cols-2 grid-cols-1 items-center md:gap-3 gap-2 w-full">
                            {/* <SearchSelect
                            list={countries}
                            placeholder="Country"
                            value={hardCopyCountry}
                            focus={newDeliveryFocus.country}
                            setValue={setHardCopyCountry}
                            setFocus={handleFocusCountry}
                            isLabeled={false}
                          /> */}
                            <SelectSearch
                              placeholder="Select Country"
                              value={hardCopyCountry? hardCopyCountry.value : ""}
                              setValue={(val) => setHardCopyCountry(countries.find(c => c.value === val))}
                              list={countries}
                              activeDropdown={activeDropdown}
                              setActiveDropdown={setActiveDropdown}
                              dropdownId="country"
                            />
                            <SearchSelect
                              list={
                                hardCopyCountry
                                  ? [
                                    "United States",
                                    "Puerto Rico",
                                    "U.S. Virgin Islands",
                                  ].includes(hardCopyCountry.label)
                                    ? USPriorDelivery
                                    : otherCitiesDelivery
                                  : []
                              }
                              placeholder="Delivery"
                              value={hardCopyMethod}
                              focus={newDeliveryFocus.delivery}
                              setValue={setHardCopyMethod}
                              setFocus={handleFocusDelivery}
                            />
                          </div>

                          <div className="grid sm:grid-cols-2 grid-cols-1 items-center md:gap-3 gap-2 w-full">
                            <FormTextInput
                              placeholder={"First Name"}
                              value={hardCopyFirstName}
                              onChange={setHardCopyFirstName}
                            />
                            <FormTextInput
                              placeholder={"Last Name"}
                              value={hardCopyLastName}
                              onChange={setHardCopyLastName}
                            />
                          </div>

                            <div className="quoteDetailsInputsContainer">
                              <SelectSearch
                                placeholder="Select State"
                                value={hardCopyState ? hardCopyState.value : ""}
                                setValue={(val) => setHardCopyState(getStates(hardCopyCountry.value).find(s => s.value === val))}
                                list={getStates(hardCopyCountry.value)}
                                activeDropdown={activeDropdown}
                                setActiveDropdown={setActiveDropdown}
                                dropdownId="state"
                                disabled={!hardCopyCountry.value}
                              />
                              <SelectSearch
                                placeholder="Select City"
                                value={hardCopyCity ? hardCopyCity.value : ""}
                                setValue={(val) =>setHardCopyCity(getCities(hardCopyState.value,hardCopyCountry.value).find(c => c.value === val))}
                                list={getCities(hardCopyState.value,hardCopyCountry.value)}
                                activeDropdown={activeDropdown}
                                setActiveDropdown={setActiveDropdown}
                                dropdownId="city"
                                disabled={!hardCopyCountry.value || !hardCopyState.value}
                              />
    
                                <FormTextInput
                                  placeholder={"ZIP code"}
                                  value={hardCopyZipCode}
                                  onChange={setHardCopyZipCode}
                                />
                            </div>
                          <div className="quoteDetailsInputsContainer">
                            <FormTextInput
                              placeholder={"Street/Address"}
                              value={hardCopyStreet}
                              onChange={setHardCopyStreet}
                            />
                          </div>
                          <div className="quoteDetailsInputsContainer">
                            <FormTextInput
                              placeholder={"Apartment, suite, etc."}
                              value={hardCopyApartment}
                              onChange={setHardCopyApartment}
                            />
                          </div>
                          <div
                            className="hardCopyCheckboxLine"
                            onClick={() =>
                              setHardCopyRequireSignature((hc) => !hc)
                            }
                          >
                            <div
                              className={`${hardCopyRequireSignature && "hardCopyChecked"
                                } hardCopyCheckbox`}
                            >
                              <Check
                                className="hardCopyCheck"
                                style={{
                                  opacity: hardCopyRequireSignature ? 1 : 0,
                                }}
                              />
                            </div>
                            <p className="hardCopyCheckboxText">
                              Require signature for delivery $4.99
                            </p>
                          </div>
                          {userData && <div
                            className="hardCopyCheckboxLine"
                            onClick={() => setSaveAddress((hc) => !hc)}
                          >
                            <div
                              className={`${saveAddress && "hardCopyChecked"
                                } hardCopyCheckbox`}
                            >
                              <Check
                                className="hardCopyCheck"
                                style={{ opacity: saveAddress ? 1 : 0 }}
                              />
                            </div>
                            <p className="hardCopyCheckboxText">Save address</p>
                          </div>}
                          {saveAddress ? (
                            <div className="quoteDetailsInputsContainer">
                              <FormTextInput
                                placeholder={"Address Name"}
                                value={addressName}
                                onChange={setAddressName}
                              />
                            </div>
                          ) : null}
                        </div>
                      )
                    ) : null}
                  </div>
                ) : null}
              </div>
              
              {order.type === "business" && (
                <div className="quotePrimaryOptionsWrapper">
                  <h3 className="quotePrimaryTitle">
                    Your Client{" "}
                    <span style={{ color: "#9A9FA7", fontWeight: 500 }}>
                      {"(optional)"}
                    </span>
                  </h3>
                  <p
                    className="quotePrimaryOptionText"
                    style={{ marginBottom: "1rem" }}
                  >
                    If submitted, the client field will be included in emails,
                    in translations, and in your invoice.
                  </p>
                  <div className="quoteDetailsInputsContainer">
                    <FormTextInput
                      placeholder={"Client First Name"}
                      value={clientFirstName}
                      onChange={setClientFirstName}
                    />
                    <FormTextInput
                      placeholder={"Client Last Name"}
                      value={clientLastName}
                      onChange={setClientLastName}
                    />
                  </div>
                  {similarClients.length > 0 && (
                    <div className="orderOptionSimilarClient">
                      <p className="orderOptionSimilarClientText">
                        We found similar clients in your account. Would you like
                        to select one of them for this order?
                      </p>
                      <div className="orderOptionSimilarClientTabs">
                        {similarClients.map((client) => (
                          <div
                            key={client.id}
                            className="orderOptionSimilarClientTab"
                            style={{
                              borderColor:
                                client.firstName + client.lastName ===
                                  clientFirstName + clientLastName
                                  ? "#B3E4EB"
                                  : "#E6E7E9",
                            }}
                            onClick={() => handleClientSelect(client)}
                          >
                            {(client.firstName
                              ? client.firstName
                              : client.name) +
                              " " +
                              (client.lastName ? client.lastName + " " : "") +
                              "(" +
                              client.totalOrders +
                              " orders)"}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              <div>
                {!phoneScreen && (
                  <div className="quoteSubmitButtonContainer">
                    <NewButton
                      text="Back to Details"
                      onClick={(e) => transitionTo("/order/documents", e)}
                      back={true}
                    />
                    <NewButton
                      text={continueButton}
                      disabled={
                        !order.type ||
                        order.languageFrom === "" ||
                        checkForHardCopyFields() ||
                        (hardCopy && saveAddress && addressName === "")
                      }
                      onClick={() => handleContinueToPayment()}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="mainOrderSecondaryContent">
            <div className="mainOrderSecondaryContentWrap">
              <div className="orderSummary">
                <h2 className="orderSummaryTitle">SUMMARY</h2>
                <div className="orderSummaryInfoWrapper">
                  <div className="orderSummaryInfo">
                    <h4 className="orderSummaryInfoType">
                      {order.certified
                        ? "Certified Translation"
                        : "Standard Translation"}
                    </h4>
                    <h4 className="orderSummaryInfoType">
                      {order.pagesCount !== ""
                        ? "$" + getOrderPageCountTotal(order).toFixed(2)
                        : "$0.00"}
                    </h4>
                  </div>
                  <p className="orderSummaryInfoCount">
                    {order.pagesCount !== ""
                      ? order.pagesCount +
                      " pages (" +
                      parseInt(order.pagesCount, 10) * 250 +
                      " words max)"
                      : "0 pages (0 words max)"}
                  </p>
                  {order.languageFrom && order.languageTo && (
                    <p className="orderSummaryInfoCount">
                      {getLanguage(order.languageFrom)} to{" "}
                      {getLanguage(order.languageTo)}
                    </p>
                  )}
                </div>

                {notarization ||
                  expedited ||
                  expeditedPlus ||
                  (hardCopy &&
                    (newAddressModal
                      ? hardCopyCountry !== ""
                      : selectedMyCountry !== "") &&
                    (newAddressModal
                      ? hardCopyMethod !== ""
                      : selectedMyMethod !== "")) ||
                  (hardCopy && hardCopyRequireSignature) ? (
                  <div className="orderSummaryInfoWrapper">
                    <div className="orderSummaryInfo">
                      <h4 className="orderSummaryInfoType">Services</h4>
                      <h4 className="orderSummaryInfoType">
                        {getServicesTotal() === 0
                          ? "Free"
                          : formatTotal(getServicesTotal())}
                      </h4>
                    </div>
                    {notarization ? (
                      <div className="orderSummaryInfo">
                        <p className="orderSummaryInfoCount">Notarization</p>
                        <p className="orderSummaryInfoCount">$34.90</p>
                      </div>
                    ) : null}
                    {expeditedPlus || expedited ? (
                      <div className="orderSummaryInfo">
                        <p className="orderSummaryInfoCount">
                          {order.expeditedPlus ? "Expedited+" : "Expedited"}{" "}
                          Turnaround
                        </p>
                        <p className="orderSummaryInfoCount">
                          {formatTotal(
                            getExpedited(order, false, expeditedPlus, expedited, false, getExpeditedFeeOption(userData, teamData))
                          )}
                        </p>
                      </div>
                    ) : null}
                    {hardCopy &&
                      (newAddressModal
                        ? hardCopyCountry !== ""
                        : selectedMyCountry !== "") &&
                      (newAddressModal
                        ? hardCopyMethod !== ""
                        : selectedMyMethod !== "") ? (
                      <div className="orderSummaryInfo">
                        <p className="orderSummaryInfoCount">Mail Hard Copy</p>
                        <p className="orderSummaryInfoCount">
                          {formatTotal(
                            getHardCopyPrice(
                              newAddressModal
                                ? hardCopyCountry.label
                                : selectedMyCountry,
                              newAddressModal
                                ? hardCopyMethod
                                : selectedMyMethod,
                              false
                            )
                          )}
                        </p>
                      </div>
                    ) : null}
                    {hardCopy && hardCopyRequireSignature ? (
                      <div className="orderSummaryInfo">
                        <p className="orderSummaryInfoCount">
                          Signature Required for Delivery
                        </p>
                        <p className="orderSummaryInfoCount">$4.99</p>
                      </div>
                    ) : null}
                  </div>
                ) : null}

                {order.discount > 0 && (
                <div className="orderSummaryInfo">
                  <h4 className="orderSummaryInfoType">Discount ({order.discount}%)</h4>
                  <h4 className="orderSummaryInfoType">
                    {formatDiscount(getDiscount(order))}
                  </h4>
                </div>
                )}

                <div className="orderSummaryTotal">
                  <h4>Total</h4>
                  <h4>
                    {formatTotal(
                      getTotal(
                        order,
                        false,
                        false,
                        notarization,
                        expedited,
                        expeditedPlus,
                        hardCopy,
                        newAddressModal ? hardCopyCountry.label : selectedMyCountry,
                        newAddressModal ? hardCopyMethod : selectedMyMethod,
                        hardCopyRequireSignature, 
                        getExpeditedFeeOption(userData, teamData)
                      ) - getDiscount(order)
                    )}
                  </h4>
                </div>
              </div>

              <div>
                <SecureAndPrivate order={order} expedited={expedited} expeditedPlus={expeditedPlus} />
                {phoneScreen && (
                  <div className="quoteSubmitButtonContainer">
                    <NewButton
                      text="Back to Details"
                      onClick={(e) => transitionTo("/order/documents", e)}
                      back={true}
                    />
                    <NewButton
                      text={continueButton}
                      disabled={
                        !order.type ||
                        order.languageFrom === "" ||
                        checkForHardCopyFields() ||
                        (hardCopy && saveAddress && addressName === "")
                      }
                      onClick={() => handleContinueToPayment()}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderOptions;
